<template>
  <div v-if="visible" class="mfa-banner">
    <span class="material-symbols-rounded text-xl text-amber-600">warning</span>
    <div class="flex-1">
      <span class="font-medium text-amber-900">{{ t('ui.mfa.recommended.bannerMessage') }}</span>
      <span class="text-amber-700 text-sm"> {{ t('ui.mfa.recommended.bannerSuggestion') }}</span>
    </div>
    <Button :label="t('ui.mfa.recommended.bannerAction')" size="small" @click="$emit('setup')" />
    <button class="text-amber-400 hover:text-amber-600 transition-colors" @click="$emit('dismiss')">
      <span class="material-symbols-rounded text-xl">close</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import Button from 'primevue/button';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{ visible: boolean }>();
defineEmits<{
  setup: [];
  dismiss: [];
}>();
</script>

<style scoped>
@reference 'tailwindcss';

.mfa-banner {
  @apply flex items-center gap-3 px-4 py-3 bg-amber-50 border border-amber-200 rounded-xl;
}
</style>
